export default {
  name: "NewAcceptanceStatusMixin",
  data: {
    acceptanceSteps: {
      ACCEPT: "accept",
      RETRY: "retry",
      SUCCESS: "success",
    },
  },
};
